<template>
  <van-popup v-model="show" round position="bottom" closeable @close="close" :style="{ height: '70%' }" :safe-area-inset-bottom="true">
    <div class="custom-account-popup">
      <div class="title">{{ title }}</div>
      <van-field
        v-if="type === 'sf'"
        label="收费日期："
        :is-link="app.permission.op('fee_charge_edit_time')"
        readonly
        placeholder="请选择"
        input-align="right"
        :border="false"
        @click="chooseChargeDate"
      >
        <template #input>
          <div style="color: var(--g8)">
            {{ chargeDate }}
          </div>
        </template>
      </van-field>
      <div class="more-account-wrapper">
        <van-cell
          center
          class="more-account-item"
          v-for="item in paymentRecordDetailList"
          :key="item.paymentAccountCustomId"
          :border="false"
        >
          <template #title>
            <van-checkbox v-model="item.checked">{{ item.name }}</van-checkbox>
          </template>
          <template v-if="item.checked">
            <van-field
              class="input"
              v-model="item.money"
              input-align="right"
              type="number"
              placeholder="请输入金额"
              :formatter="app.tool.format2MaxWrap(oweMoney)"
            />
          </template>
        </van-cell>
      </div>

      <div class="info">
        <div class="left" v-if="app.permission.op('payment_account_offline_custom_set')">
          设置{{type === 'tf' ? '退' : '收'}}款账户，<span class="btn" @click="$router.push('/sf/set/offline-channel')"
            >去设置></span
          >
        </div>
        <div v-else></div>
        <div class="right">
          <div>
            {{type === 'tf' ? '退' : '收'}}款金额: <span class="money">¥{{ oweMoney | formatNumber }}</span>
          </div>
          <div v-if="diffMoney < 0" class="warn">
            <van-icon name="info" size="14" color="var(--c3)"/>&nbsp;还差: <span class="money red">¥{{ -diffMoney | formatNumber }}</span>
          </div>
          <div v-if="diffMoney > 0" class="warn">
            <van-icon name="info" size="14" color="var(--c3)"/>&nbsp;超额: <span class="money red">¥{{ diffMoney | formatNumber }}</span>
          </div>
        </div>
      </div>

      <page-footer-btn multipleBtns>
        <van-button
          square
          round
          block
          type="primary"
          @click="dosomething"
          :disabled="diffMoney !== 0"
        >
          <template v-if="type === 'sf'">
            确认收款：{{ oweMoney | formatNumber }}
          </template>
          <template v-else>
            确定
          </template>
        </van-button>
      </page-footer-btn>
    </div>
  </van-popup>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'custom-account-popup',
  data() {
    return {
      show: false,
      cdate: '',
      paymentRecordDetailList: [],
      oweMoney: 0,
      title: '线下收款',
      type: 'sf',
    };
  },
  components: {
    pageFooterBtn,
  },
  computed: {
    // 收费日期
    chargeDate() {
      return app.tool.date.formatDatetime(this.cdate, 'yyyy-MM-dd');
    },
    calcMoney() {
      const list = this.paymentRecordDetailList.filter(item => item.checked);
      const total = list.reduce((pre, cur) => {
        return pre + Number(cur.money);
      }, 0);
      return total;
    },
    diffMoney(){
      return Number(((this.calcMoney * 1000 - this.oweMoney * 1000) / 1000).toFixed(2));
    },
  },
  methods: {
    dosomething() {
      if (this.paymentRecordDetailList.some(item=>{
        return item.checked && item.money == 0
      })) {
        vant.Toast('账户金额必须大于0');
        return;
      }

      try {
        const p = this.paymentRecordDetailList.find(item=>item.checked);
        if (p) {
          app.ls.setStorage('custom-account-last', p.paymentAccountCustomId);
        }
      } catch(e) {

      }
      this._rsv &&
        this._rsv({
          cdate: this.cdate,
          paymentRecordDetailList: this.paymentRecordDetailList,
        });
    },
    open({ cdate, paymentRecordDetailList, oweMoney, type = 'sf' }) {
      this.show = true;
      this.type = type;
      if (type === 'order') {
        this.title = '修改收款账户';
      } else if (type === 'tf') {
        this.title = '选择退款账户'
      }
      this.cdate = cdate;
      this.oweMoney = +oweMoney;
      this.paymentRecordDetailList = JSON.parse(JSON.stringify(paymentRecordDetailList));

      let arr = this.paymentRecordDetailList.filter(v=> v.checked);
      if (type !== 'order' && arr.length == 0) {
        const saveId = app.ls.getStorage('custom-account-last');
        let p = this.paymentRecordDetailList[0];
        if (saveId && this.paymentRecordDetailList.find(item=>item.paymentAccountCustomId === saveId)) {
          p = this.paymentRecordDetailList.find(item=>item.paymentAccountCustomId === saveId);
        }
        if (p) {
          p.checked = true;
          p.money = oweMoney;
        }
      }

      return new Promise((rsv, rej) => {
        this._rsv = rsv;
        this._rej = rej;
      });
    },
    close() {
      this._rej && this._rej();
    },
    async chooseChargeDate() {
      if (app.permission.op('fee_charge_edit_time')){
        let res = await app.x3.picker.calendar({
          defaultDate: this.cdate,
          minDate: new Date(2020, 1, 1),
          maxDate: new Date(),
        });
        this.cdate = res;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-account-popup {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.title {
  height: 44px;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--g8);
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
}
.more-account-wrapper {
  overflow: auto;
  flex: 1 1 auto;
  .more-account-item {
    padding: 6px 16px;
    height: 50px;
    ::v-deep .input {
      border: 1px solid var(--g3);
      padding: 5px 12px;
      border-radius: 8px;
    }
    ::v-deep .van-cell__value {
      flex: 0 0 auto;
    }
    ::v-deep input {
      width: 96px;
    }
  }
}

.info {
  flex: 0 0 auto;
  background: var(--g1);
  display: flex;
  justify-content: space-between;
  padding: 16px 16px;
  .left {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    color: var(--g6);
    .btn {
      color: var(--c1);
    }
  }
  .right {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g8);
    text-align: right;
    .money {
      font-weight: bold;
      margin-left: 5px;
    }
    .red {
      color: var(--c3);
    }
    .warn {
      display:flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>